import moment from 'moment';
import {
  PHASE_ORDER_MAP,
  PLATFORM_ORDER,
  RELEASED_PHASE_ORDER,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/GameInfo/components/ReleaseDate/_config';
import { IReleaseDateSortObj } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/GameInfo/components/ReleaseDate/MoreReleaseDateModal';

const isEmpty = (val: any) => val === null || val === undefined || val === '';

const compare = (aVal: number | string, bVal: number | string, sortType: 'desc' | 'asc') => {
  if (isEmpty(aVal) || isEmpty(bVal)) return -1;

  if (aVal < bVal) return sortType === 'desc' ? 1 : -1;
  if (aVal > bVal) return sortType === 'desc' ? -1 : 1;
  return 0;
};

export const sortReleaseDateData = (
  data: any[],
  sortObj: IReleaseDateSortObj,
  releaseType: 'not_release' | 'released' | 'offline',
) => {
  const phaseOrder = PHASE_ORDER_MAP[releaseType] || RELEASED_PHASE_ORDER;

  return (
    data?.sort((a: any, b: any) => {
      const { key: sortKey, sortVal: sortType } = sortObj;

      const phaseComparison = compare(
        phaseOrder.indexOf(a.originStatus),
        phaseOrder.indexOf(b.originStatus),
        sortKey === 'status' ? sortType : 'desc',
      );

      const platformComparison = compare(
        PLATFORM_ORDER.indexOf(a.platform),
        PLATFORM_ORDER.indexOf(b.platform),
        sortKey === 'platform' ? sortType : 'desc',
      );

      const dateComparison = compare(
        a.release_date ? moment(a.release_date).valueOf() : 0,
        a.release_date ? moment(b.release_date).valueOf() : 0,
        // 主排序指标非时间排序时，时间升序，从早到晚
        sortKey === 'release_date' ? sortType : 'asc',
      );

      const countryComparison = compare(
        a.originCountry,
        b.originCountry,
        // 主排序指标非国家排序时，使用升序，a - z
        sortKey === 'country' ? sortType : 'asc',
      );

      let comparison = 0;

      if (sortKey === 'status') {
        comparison = phaseComparison;
      } else if (sortKey === 'platform') {
        comparison = platformComparison;
      } else if (sortKey === 'release_date') {
        comparison = dateComparison;
      } else if (sortKey === 'country') {
        comparison = countryComparison;
      }

      if (comparison !== 0) return comparison;

      // 降级排序
      if (platformComparison !== 0) return platformComparison;
      if (phaseComparison !== 0) return phaseComparison;
      if (dateComparison !== 0) return dateComparison;
      if (countryComparison !== 0) return countryComparison;

      return 0;
    }) || []
  );
};
